import request from '@/utils/request'
const apiPath = '/cust/ManageHomeStatistics'
const homeStatisticsApi = {
  findCashMoney(query) {
    return request.get(apiPath + '/findCashMoney', { params: query })
  },
  findOrder(query) {
    return request.get(apiPath + '/findOrder', { params: query })
  },
  findMoneyTotalByDate(query) {
    return request.get(apiPath + '/findMoneyTotalByDate', { params: query })
  },

  exceptionCount(query) {
    return request.get('/cust/userWallet/exceptionCount', { params: query })
  },
  findHomeAllUserWallet(query) {
    return request.get(apiPath + '/findHomeAllUserWallet', { params: query })
  },

  findHomeToDoList(query) {
    return request.get(apiPath + '/findHomeToDoList', { params: query })
  },
  getHomeException(query) {
    return request.get(apiPath + '/getHomeException', { params: query })
  },
  classifyChangeList(query) {
    return request.get(apiPath + '/classifyChangeList', { params: query })
  },
  complianceStandardsK(query) {
    return request.get(apiPath + '/complianceStandardsK', { params: query })
  },
  imConversationStatistics(query) {
    return request.get(apiPath + '/imConversationStatistics', { params: query })
  },

  //大屏-商品排名
  sysGoodsRanking(query) {
    return request.get(apiPath + '/sysGoodsRanking', { params: query })
  },
  //大屏-技术老师服务
  technicianServiceOrderStatistics(query) {
    return request.get(apiPath + '/technicianServiceOrderStatistics', { params: query })
  },
  //大屏-收款
  screenPay(query) {
    return request.get(apiPath + '/screenPay', { params: query })
  },
  // 大屏-客户情况-客户分类-app用户-业务情况
  screenCustomer(query) {
    return request.get(apiPath + '/screenCustomer', { params: query })
  },
}
export default homeStatisticsApi
